// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import ContentBlock from '/react4xp/components/ContentBlock'
import Image from '/react4xp/components/Image'
import Video from '/react4xp/components/Video'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface OurValuesProps {
    tag?: string
    title?: string
    intro?: string
    contentBlock?: Array<{
        img?: {
            srcSmall?: string
            srcMedium?: string
            src: string
            alt: string
        }
        title?: string
        text?: string
    }>
    image?: {
        srcSmall?: string
        srcMedium?: string
        srcLarge?: string
        src: string
        alt: string
    }
    video?: {
        type: 'youtube' | 'vimeo' | 'default'
        url: string
        poster?: string
    }
    caption?: string
    bgColor?: 'green' | 'beige' | 'none'
}

export default function OurValues({
    tag,
    title,
    intro,
    contentBlock,
    image,
    video,
    caption,
    bgColor
}: OurValuesProps) {
    return (
        <Section textColor='text-dark' className='our-values'>
            <div className='grid-container'>

                <div className={clsx(
                    'our-values__header',
                    contentBlock && 'our-values__header--has-content-blocks'
                )}>

                    {isNonWhitespaceString(tag) && (
                        <p className='tagline-md tagline'>
                            {tag}
                        </p>
                    )}

                    {isNonWhitespaceString(intro) ? (
                        <div className='grid-row'>

                            <div className='c-12 c-md-6'>
                                {isNonWhitespaceString(title) && (
                                    <h2 className='title-md title'>
                                        {title}
                                    </h2>
                                )}
                            </div>

                            <div className={clsx(
                                'c-12 c-md-6 right-col',
                                contentBlock && 'right-col--has-content-blocks'
                            )}>
                                <div dangerouslySetInnerHTML={{ __html: intro }} suppressHydrationWarning />
                            </div>

                        </div>
                    ) : (
                        <>                            
                            {isNonWhitespaceString(title) && (
                                <h2 className='title-md title'>
                                    {title}
                                </h2>
                            )}
                        </>
                    )}
                    

                </div>

                <div className='our-values__content'>

                    {contentBlock && (
                        <div className='content-blocks'>

                            <div className='grid-row'>
                                {contentBlock.map((item, i) => (
                                    <div className='c-md-4' key={i}>
                                        <ContentBlock
                                            img={{
                                                srcSmall: [`${item.img.srcSmall}`, 574], // 400x300
                                                srcMedium: [`${item.img.srcMedium}`, 991], // 900x600
                                                src: item.img.src, // 450x450
                                                alt: item.img.alt
                                            }}
                                            title={item.title}
                                            text={item.text}
                                        />
                                    </div>
                                ))}
                            </div>

                            <div className='our-values__line'></div>

                        </div>
                    )}

                    {(image || video) ? (
                        <>
                            <div className='our-values__media-wrapper-outside'>

                                {bgColor && (
                                    <div className={clsx(
                                        'bg-color',
                                        bgColor === 'beige' && 'bg-beige-400',
                                        bgColor === 'green' && 'bg-green-300'
                                    )}></div>
                                )}
                                
                                <div className='our-values__media-wrapper'>

                                    {image && !video && (
                                        <Image
                                            srcSmall={[image.srcSmall, 574]} // 550x320
                                            srcMedium={[image.srcMedium, 991]} // 900x500
                                            src={image.src} // 1350x750
                                            alt={image.alt}
                                            className='cover'
                                        />
                                    )}

                                    {video && (
                                        <Video
                                            video={{
                                                videoType: video.type,
                                                url: video.url,
                                                poster: image?.src,
                                                posterMedium: image?.srcMedium
                                            }}
                                            className='cover'
                                        />
                                    )}

                                </div>
                            </div>

                            {isNonWhitespaceString(caption) && (
                                <p className='our-values__caption'>
                                    {caption}
                                </p>
                            )}
                        </>
                    ) : null}

                    {(image || video) && (!bgColor || (bgColor !== 'green' && bgColor !== 'beige')) && contentBlock && (
                        <div className='our-values__line our-values__line--last'></div>
                    )}

                </div>

            </div>
        </Section>
    )
}

